import jwtService from '../../../../services/jwtService';
import {setUserDataTracknMe} from './user.actions';


export const LOGIN_ERROR = 'LOGIN_ERROR';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';

export function submitLogin({email, password, brand})
{
    return (dispatch) =>
        jwtService.signInWithEmailAndPassword(email, password,brand)
            .then((session) => {
                
                setPermissions(session.permissions)
            
                 if(session.permissions && session.permissions.length > 0){
                    
                    dispatch(setUserDataTracknMe(session));
                    
                    return dispatch({
                        type: LOGIN_SUCCESS
                    });
                        
                }
           
            })
            .catch(error => {
            
                return dispatch({
                    type   : LOGIN_ERROR,
                    payload: error
                });
            });
}

function setPermissions(permissions) {
    let currentPermissions;
    var arrayPermissions = [];
    permissions.forEach(function (permission){
        if (permission.name.includes('MONITORING')) {
            arrayPermissions.push(permission)
            setPermissionsStatus(permission.name,permission.type)
        }else if (permission.name.includes('ERP_WEB')) {
            arrayPermissions.push(permission)
            setPermissionsStatus(permission.name,permission.type)
        }
    });
   
    currentPermissions = arrayPermissions;
    sessionStorage.setItem('permissions', JSON.stringify(currentPermissions));
}

function setPermissionsStatus( permission, type) {
    sessionStorage.setItem(permission, type);
}

